import React, { useEffect } from 'react';
import { useChat } from '../context/ChatProvider';
import { RequestCard } from './RequestCard'; // This component is the next one to redesign
import useSound from 'use-sound';
import { FaInbox } from 'react-icons/fa';

// ===================================================================================
// A. Polished Empty State Component
// Shown when there are no incoming chat requests.
// ===================================================================================
const EmptyInbox = () => (
    <div className="flex flex-col items-center justify-center h-full text-center p-6 text-slate-500">
        <FaInbox size={32} className="mb-3" />
        <p className="font-semibold text-slate-400">Inbox is Clear</p>
        <p className="text-sm">New requests will appear here.</p>
    </div>
);

// ===================================================================================
// B. The Main Inbox Panel Component
// ===================================================================================
export function InboxPanel() {
    const { requests, acceptRequest } = useChat();
    // The notification sound is a great feature, so we keep it as is.
    const [playNotification] = useSound('/sounds/notification.mp3', { volume: 0.7 });

    useEffect(() => {
        if (requests?.length > 0) {
            playNotification();
        }
    }, [requests?.length, playNotification]);

    // --- BUG FIX & IMPROVEMENT ---
    // Added a check for `requests` being undefined or null during initial load
    // to prevent potential errors.
    if (!requests) {
        // You could add a skeleton loader here if initial loading takes time
        return <EmptyInbox />;
    }

    return (
        <div className="p-2 space-y-2">
            {requests.length > 0 ? (
                requests.map((req) => (
                    // The 'RequestCard' component will be redesigned next to fit this new container.
                    <RequestCard key={req.userId} request={req} onAccept={acceptRequest} />
                ))
            ) : (
                <EmptyInbox />
            )}
        </div>
    );
}